import { useDispatch } from "react-redux";

import { truncateText } from "../../../utils/generic";
import useCurrentUser from "../../../hooks/useCurrentUser";
import { updateNotification } from "./base.utils";
import { useRequestNotificationPermission } from "./useRequestNotificationPermission";
import { useCallback } from "react";

export const usePushSystemNotification = (userData: Record<string, any> = {}) => {
  const dispatch = useDispatch();
  const { user } = useCurrentUser();
  const { permission, requestPermission, isNotificationAvailable } = useRequestNotificationPermission();

  return useCallback(
    (modifiedNotification: Record<string, any>, onClick?: (...args: any[]) => void) => {
      const _data = userData[modifiedNotification.type][modifiedNotification.event];

      if (!isNotificationAvailable()) {
        alert("This browser does not support desktop notification");
      } else if (permission === "granted") {
        const notification = new Notification(_data.title, {
          silent: false,
          body: `#${truncateText(modifiedNotification.id, 15)}`,
          actions: [],
        });

        notification.onclick = () => {
          updateNotification(modifiedNotification, user.id!, dispatch);
          onClick?.(modifiedNotification);
        };
      } else if (permission !== "denied") {
        requestPermission();
      }
    },
    [dispatch, isNotificationAvailable, permission, requestPermission, user.id, userData]
  );
};
